/* 中文词典：host 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const host = {
  // —— 大厅协议（host/lobby.ts）——
  'host.lobby.versionMismatchKick': [ '游戏版本不一致，无法加入房间' ],
  'host.lobby.versionMismatch': [ '游戏版本不一致，无法加入房间' ],
  'host.lobby.roomFull': [ '房间已满（最多 ', { type: 'param', name: 'n' }, ' 人）' ],
  // —— 联机一桌（host/online.ts）——
  'host.online.nextGame': [ '换一局' ],
  // —— 规则适配器（host/rules.ts）——
  'host.rules.missingStartOptions': [ '开局没有带配置（EkStartOptions）' ],
  'host.rules.startFailed': [ '开局失败：', { type: 'param', name: 'problems' } ],
  'host.rules.startFailedAction': [ '开局失败（', { type: 'param', name: 'action' }, '）：', { type: 'param', name: 'reason' }, '｜房主=', { type: 'param', name: 'host' }, '｜名册=[', { type: 'param', name: 'roster' }, ']' ],
  'host.rules.hostOnlyPresence': [ '只有房主能改玩家的连接状态' ],
  'host.rules.actorMismatch': [ '这个动作自称是 ', { type: 'param', name: 'claimed' }, ' 发的，但实际来自 ', { type: 'param', name: 'actual' } ],
  'host.rules.stealOrderFallback': [ '追问被抽人的手牌顺序失败，按房主侧顺序结算：' ],
  // —— RPC（net/rpc.ts）——
  'host.rpc.localError': [ '本地异常:' ],
  'host.rpc.undecodable': [ '来自 ', { type: 'param', name: 'from' }, ' 的消息无法解析' ],
  'host.rpc.envelopeOnNotify': [ '信封 ', { type: 'param', name: 't' }, ' 出现在通知通道上' ],
  'host.rpc.envelopeOnRequest': [ '信封 ', { type: 'param', name: 't' }, ' 出现在请求通道上' ],
  'host.rpc.duplicateMethod': [ '方法 ', { type: 'param', name: 'method' }, ' 已经注册过了；方法名必须唯一' ],
  'host.rpc.disposed': [ 'RPC 已销毁' ],
  'host.rpc.responseUndecodable': [ '来自 ', { type: 'param', name: 'to' }, ' 的响应无法解析（', { type: 'param', name: 'method' }, '）' ],
  'host.rpc.responseNotResponse': [ '来自 ', { type: 'param', name: 'to' }, ' 的响应不是响应信封（', { type: 'param', name: 'method' }, '）' ],
  'host.rpc.responseIdMismatch': [ '响应的 id 对不上（期望 ', { type: 'param', name: 'expected' }, '，收到 ', { type: 'param', name: 'received' }, '）' ],
  'host.rpc.responseBadPayload': [ '来自 ', { type: 'param', name: 'to' }, ' 的响应体不符合约定（', { type: 'param', name: 'method' }, '）' ],
  'host.rpc.disposedPending': [ 'RPC 已销毁，请求 ', { type: 'param', name: 'method' }, ' 不会再有响应' ],
  'host.rpc.peerPardon': [ '对端报障（', { type: 'param', name: 'method' }, '）：', { type: 'param', name: 'reason' } ],
  'host.rpc.timeout': [ { type: 'param', name: 'method' }, ' 超时' ],
  'host.rpc.aborted': [ { type: 'param', name: 'method' }, ' 被中止' ],
  'host.rpc.rejected': [ { type: 'param', name: 'method' }, ' 被对端拒绝' ],
  'host.rpc.undelivered': [ { type: 'param', name: 'method' }, ' 未送达（连接已断开）' ],
  // —— 房间级连接层（net/peer.ts）——
  'host.peer.pardonReceived': [ '收到来自 ', { type: 'param', name: 'from' }, ' 的报障单：', { type: 'param', name: 'reason' } ],
  'host.peer.heartbeatMiss': [ '心跳 ', { type: 'param', name: 'peer' }, ' 第 ', { type: 'param', name: 'n' }, ' 次失败：', { type: 'param', name: 'error' } ],
  // —— 信令/传输（net/trystero.ts）——
  'host.relay.noneConfigured': [ '没有配置任何信令中继。' ],
  'host.relay.timeout': [ { type: 'param', name: 'seconds' }, ' 秒内一个信令中继都没连上。' ],
  'host.relay.allFailed': [ '所有信令中继都连不上。' ],
  'host.trystero.signalError': [ '信令层异常:' ],
  'host.trystero.joinFailed': [ '加入房间失败：', { type: 'param', name: 'error' } ],
  'host.trystero.noRequestHandler': [ '没有注册请求处理器' ],
  'host.trystero.disposed': [ '传输层已销毁' ],
  'host.trystero.pingTimeout': [ 'ping ', { type: 'param', name: 'id' }, ' 超时' ],
  // —— 旁路通道（net/side.ts）——
  'host.side.emptyKind': [ '旁路通道的 kind 不能是空的' ],
  // —— 对局级同步（net/session.ts）——
  'host.session.subscriberError': [ 'session：', { type: 'param', name: 'what' }, ' 的订阅者抛了异常' ],
  'host.session.statusSubscriberError': [ 'session：状态订阅者抛了异常' ],
  'host.session.rosterSubscriberError': [ 'session：名册订阅者抛了异常' ],
  'host.session.viewLabel': [ '视图' ],
  'host.session.eventLabel': [ '事件' ],
  'host.session.projectBeforeStart': [ '还没开局就要求投影' ],
  'host.session.notHost': [ '我不是房主' ],
  'host.session.prepareFailed': [ '结算前的询问失败了：', { type: 'param', name: 'reason' } ],
  'host.session.resyncBadView': [ '重同步拿到的视图不符合约定' ],
  'host.session.resyncHashMismatch': [ '重同步拿到的视图哈希也对不上 —— 双方对同一份状态算出了不同的视图' ],
  'host.session.fullViewBad': [ '房主推来的全量视图不符合约定' ],
  'host.session.patchApplyFailed': [ '增量无法应用' ],
  'host.session.viewHashMismatch': [ '视图哈希对不上（seq ', { type: 'param', name: 'seq' }, '），回退到全量' ],
  'host.session.hostLeftRoom': [ '房主已离开房间' ],
  'host.session.notInGame': [ { type: 'param', name: 'from' }, ' 不在这一局里' ],
  'host.session.hostEnded': [ '房主结束了这一局' ],
  'host.session.pardonReceived': [ '收到 ', { type: 'param', name: 'from' }, ' 的报障单：', { type: 'param', name: 'reason' } ],
  'host.session.hostPeerLeft': [ '房主离开了房间' ],
  'host.session.hostWentOffline': [ '房主掉线了' ],
  'host.session.gameEnded': [ '这一局已经结束了' ],
  'host.session.gameNotStarted': [ '这一局还没开始' ],
  'host.session.hostSuspended': [ '房主掉线了，等他回来' ],
  // —— 协议诊断（net/protocol.ts）——
  'host.protocol.payloadType': [ '载荷类型为 ', { type: 'param', name: 'type' } ],
  // —— PARDON 报障原因（net/protocol.ts 存键，pardonText() 翻译）——
  'host.pardon.badData': [ '无法解析数据流' ],
  'host.pardon.badJson': [ '无法将文本解析为 JSON' ],
  'host.pardon.badMessage': [ '消息不满足信封接口' ],
  'host.pardon.badRequest': [ '请求不满足信封接口' ],
  'host.pardon.badResponse': [ '响应不满足信封接口' ],
  'host.pardon.badMessageType': [ '未知的消息类型' ],
  'host.pardon.badMethod': [ '未知的方法类型' ],
  'host.pardon.badPayload': [ '请求不满足业务接口' ],
  'host.pardon.internalError': [ '分派请求期间抛出了异常' ],
  'host.pardon.handlerError': [ '处理请求期间抛出了异常' ],
  'host.pardon.orphanResponse': [ '响应不存在对应请求' ],
  'host.pardon.accessDenied': [ '拒绝访问' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
host satisfies Record<string, TextSpec>;
export default host;
